<script>
import pfMixin from '../../../../mixins/pfMixin'
export default {
	mixins: [pfMixin],
	components: {
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../PfModal'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../PfLoader'),
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			datos: {
				notas: ''
			},
			config: {
			events: {
				initialized: function () {
					console.log('initialized')
				}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},
	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...newData.datos})
			},
			deep: true,
			immediate: true
		}
	},
}
</script>
<template>
	<div class="pb-5">
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
	
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="">Planteamiento</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
			</div>
			
		</div>

		<div id="accordion_approach" class="pf-accordion  pb-3">
			<div class="card">
				<div class="card-header p-1" id="ap_h_1">
					<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" data-target="#ap_1" aria-expanded="true" aria-controls="ap_1">
						Factores de riesgo
					</button>
				</div>

				<div id="ap_1" class="collapse show" aria-labelledby="ap_h_1" data-parent="#accordion_approach">
					<div class="pt-5">
						<div class="col-12 mx-auto py-2">
							<label class="pf-control d-flex">
								<span class="pf-control__label">Debilidades / Amenazas / Fortalezas / Oportunidades: </span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.debilidades_amenazas_fortalezas_oportunidades"
							@change="$parent.updatedForms"
							/>
						</div>	
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="ap_h_2">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#ap_2" aria-expanded="true" aria-controls="ap_2">
						Conclusiones
					</button>
				</div>

				<div id="ap_2" class="collapse" aria-labelledby="ap_h_2" data-parent="#accordion_approach">
					<div class="pt-5">
						<div class="col-12 mx-auto py-2">
							<label class="pf-control d-flex">
								<span class="pf-control__label"></span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.conclusiones"
							@change="$parent.updatedForms"
							/>
						</div>	
					</div>
				</div>
			</div>
		</div>
	</div>
</template>